import { render, staticRenderFns } from "./CheckboxValidated.vue?vue&type=template&id=2e9948f9"
import script from "./CheckboxValidated.vue?vue&type=script&lang=js"
export * from "./CheckboxValidated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports